// src/components/settings/SettingsAvatar.jsx
import React, { useState } from "react";
import { getProfile, updateAvatar } from "../Stores/profileStore";

const SettingsAvatar = () => {
  const baseProfile = getProfile();
  const [avatar, setAvatar] = useState(baseProfile.avatarUrl || null);
  const [message, setMessage] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const dataUrl = evt.target?.result;
      if (typeof dataUrl === "string") {
        updateAvatar(dataUrl);
        setAvatar(dataUrl);
        setMessage("Foto de perfil actualizada (demo).");
      }
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="profile-settings">
      <div className="profile-header-title">
        <h1>Avatar</h1>
      </div>

      <div className="avatar-settings">
        <div className="avatar-preview">
          {avatar ? (
            <img src={avatar} alt="Avatar" className="avatar-image" />
          ) : (
            <div className="avatar-placeholder">W</div>
          )}
        </div>

        <div className="avatar-actions">
          <p className="avatar-help-text">
            Sube una imagen de tu equipo para usar como foto de perfil.
          </p>
          <label className="qe-btn qe-btn-secondary">
            Seleccionar imagen
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </label>
        </div>
      </div>

      {message && (
        <div className="profile-message profile-message-success">
          {message}
        </div>
      )}
    </div>
  );
};

export default SettingsAvatar;
